/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleCollectionOptDataRes } from '../../models/role-collection-opt-data-res';

export interface ApiRoleOptRoleCollectionsGet$Params {
}

export function apiRoleOptRoleCollectionsGet(http: HttpClient, rootUrl: string, params?: ApiRoleOptRoleCollectionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RoleCollectionOptDataRes>>> {
  const rb = new RequestBuilder(rootUrl, apiRoleOptRoleCollectionsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RoleCollectionOptDataRes>>;
    })
  );
}

apiRoleOptRoleCollectionsGet.PATH = '/api/role/opt/role-collections';
